var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{attrs:{"radius":"","color":"warning","type":"border","size":"small","icon-pack":"mdi","icon":"mdi-chevron-right"},on:{"click":function($event){return _vm.goBack()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }